import { DataContext } from 'entries/common/widgets/context';
import { useContext } from 'react';
import { FLOOR_IDS } from 'pages/common/consts/calculator-ids';

export const useIsFloorCalculator = () => {
  const data = useContext(DataContext);
  const calculatorId = data?.surfaces?.id || '';
  return FLOOR_IDS.includes(calculatorId);
};
